import React from 'react'
import { Footer } from '../presentation/Footer'
import { Header } from '../presentation/Header'
import { PrescriptionsPage } from '../presentation/PrescriptionsPage'

export const Prescriptions = () => {
  return (
    <div>
      <Header />
      <PrescriptionsPage />
      <Footer />
    </div>
  )
}